// extracted by mini-css-extract-plugin
export default {"wrapper":"ApiErrorMessage__wrapper--pCOT_","loading-shimmer":"ApiErrorMessage__loading-shimmer--C1M5o","loadingShimmer":"ApiErrorMessage__loading-shimmer--C1M5o"};